module.exports = __webpack_public_path__ + "Badge_MedicalTips-0e2fcf96c969f70023f42eb1989b04b2.svg";